export default "__VITE_ASSET__PzGNosqhvg0cqZPyiex3Ag__"